import React, { useState } from 'react'

import { Button } from '@/components/buttons/Button'
import { Pill } from '@/components/pills/Pill'
import { formatOptionWithDescription } from '@/components/helpers/selectHelpers'

import { Select } from '../Select'

export const LlmModelSelect = ({ loading, options, ...props }) => {
  const [showDetails, setShowDetails] = useState(true)

  const formatOptionLabel = (option, meta) =>
    formatOptionWithDescription(
      {
        ...option,
        description: showDetails ? option.description : undefined,
        label: option.deprecated ? (
          <span className="flex-align-center small-gap">
            {option.label}
            <Pill critical small>
              Deprecated
            </Pill>
          </span>
        ) : (
          option.label
        ),
      },
      meta
    )

  return (
    <div>
      <Button
        link
        onClick={(event) => {
          event.stopPropagation()
          setShowDetails((prev) => !prev)
        }}
      >
        {showDetails ? 'Hide Model Details' : 'Show Model Details'}
      </Button>
      <Select
        loading={loading}
        options={options}
        formatOptionLabel={formatOptionLabel}
        {...props}
      />
    </div>
  )
}
